import React from "react";

export default function ChatArena({
  children,
}: {
  children?: React.ReactNode;
}) {
  return (
    <div className="bg-chat h-screen w-full overflow-hidden  flex flex-col">
      {children}
    </div>
  );
}
